
export default {
  name: "debCamp",
  data() {
    return {
      passStatuts: false,
      data: {
        actual: '',
        nueva: '',
        nuevaRepetida: ''

      },
      inptType: 'password',

    };
  },
  mounted: function () {


    this.passStatus();

    $('#modalPass').modal({ show: false, backdrop: 'static', keyboard: false })
  },


  methods: {
    passStatus() {
      this.$http
        .get(
          "/config/pass/status/",

        )
        .then(response => {
          if (response.data.data[0] == 1) {
            $('#modalPass').modal('hide')

            $('#modalPass').modal({ show: true, backdrop: 'static', keyboard: false })
          }
        });
    },

    changePass() {
      if (this.passCheck()) {

        this.$http
          .post(
            "/config/pass/",

            this.data
          )
          .then(() => {

            alert('Contraseña actualizada')
            $('#modalPass').modal('hide')

          }).catch(() => {

            alert('No se pudo cambiar la contraseña.')
            $('#modalPass').modal('hide');
          });
      } else {
        alert('Revise que las contraseñas cumplan con los requisitos')
      }
    },

    passCheck() {


      return this.data.nueva != '' && 
      this.data.actual != '' && 
      this.data.nuevaRepetida != '' && 
      this.data.nueva == this.data.nuevaRepetida && 
      this.data.nueva != this.data.actual && 
      this.data.nueva.length > 7;
    }



  }

};



// WEBPACK FOOTER //
// ./src/components/general/cambioPass/index.js